import { useAppSelector } from "../app/hooks";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import BusinessMessages from "../features/message/components/business/business-messages";
import MemberMessagesBusinessView from "../features/message/components/member/member-messages-business-view";
import MemberMessagesMemberView from "../features/message/components/member/member-messages-member-view";
import { PermissionCode, UserType } from "../shared/enums";

const Messages = () => {
    const loggedInUser = useAppSelector(selectLoggedInUser);
    const permissions = loggedInUser?.roleData?.businessUser?.role?.permissions?.map(permission => permission.code) ?? [];

    return (
        <div>
            {loggedInUser?.type === UserType.GYMINIFY &&
                <BusinessMessages />
            }
            {permissions.includes(PermissionCode.MESSAGES_VIEW) &&
                <MemberMessagesBusinessView />
            }
            {loggedInUser?.type === UserType.MEMBER &&
                <MemberMessagesMemberView />
            }
        </div>
    )
}

export default Messages;